import {
  type JSXElementConstructor,
  type ReactElement,
  type ReactNode,
} from 'react';
import { isElement } from 'react-is';

/** @internal */
export const isSlot = <T>(
  child: ReactNode,
  slotType: JSXElementConstructor<T>,
): child is ReactElement<T> => {
  return isElement(child) && child.type === slotType;
};
